// extracted by mini-css-extract-plugin
export var phone = "_3m-0";